module.exports = __webpack_public_path__ + "pc/img/evaluatImg2.7ad675f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/onOne/evaluatImg2.jpg
// module id = 6CDk
// module chunks = 3